import { IBiosample } from '@/types/Analysis/Biosamples.types';

export type BiosampleKind = 'tumour' | 'germline' | 'rna' | 'methylation' | 'hts' | 'liquidBiopsy';

// The same conditions the get*Biosample helpers in @zero-dash/types pick from, but kept
// as a test per biosample so callers can list or choose every match rather than only the first.
export const isBiosampleOfKind: Record<BiosampleKind, (b: IBiosample) => boolean> = {
  tumour: (b) => b.biosampleType === 'dna' && (
    (['wgs', 'panel'].includes(b.sampleType) && b.biosampleStatus === 'tumour')
    || b.biosampleStatus === 'liqbiopsy'
  ),
  germline: (b) => b.biosampleType === 'dna'
    && ['wgs', 'panel'].includes(b.sampleType)
    && b.biosampleStatus === 'normal',
  rna: (b) => b.biosampleType === 'rna' && ['rnaseq', 'panel'].includes(b.sampleType),
  methylation: (b) => b.sampleType === 'methylation',
  hts: (b) => b.sampleType === 'hts',
  liquidBiopsy: (b) => b.biosampleType === 'dna' && b.biosampleStatus === 'liqbiopsy',
};
